import { act, createContext, useCallback, useContext, useEffect, useReducer } from 'react'
import { useFieldArray, useFormContext } from 'react-hook-form'

const documentContextDefault = {
  update: (lineTotal: any) => void 0,
  document: {
    total: 0,
    vat: 0,
    subTotal: 0,
  } as any,
}

export const DocumentContext = createContext(documentContextDefault)

export const DocumentLinesContext = ({ children }: { children: JSX.Element }) => {
  const { control } = useFormContext()

  const documentReducer = (documentTotal: typeof documentContextDefault, action: any) => {
    switch (action.type) {
      //   case 'calculate-total': {
      //     const newValue = documentTotal

      //     newValue.document.total =
      //     return {
      //       ...documentTotal,
      //       lines: newLines,
      //     }
      //   }

      //   case 'calculate-tax': {
      //     const newLines = documentTotal.lines.filter((line: any) => line.index === action.value.id)
      //     return {
      //       ...documentTotal,
      //       lines: newLines,
      //     }
      //   }

      //   case ' calculate-subtotal': {

      //   }

      //   case 'update-line': {
      //     documentTotal.lines[action.value.index] = action?.value as any
      //     return documentTotal
      //   }
      default:
        return documentTotal
    }
  }

  const [document, dispatch] = useReducer(documentReducer, documentContextDefault)

  //   useEffect(() => {
  //     console.log('fields: ', fields)
  //   }, [fields])

  return <DocumentContext.Provider value={{ ...document }}>{children}</DocumentContext.Provider>
}
